import { useService } from "@/services/ServiceContext";
import { useSelectedCustomer } from "./Customer";
import useSWR from "swr";
import useSWRImmutable from "swr/immutable";
import { APIService } from "@/services/APIService/APIService";
import { ResponseError } from "@/services/api";
export function useInvoices() {
	const { data: customer } = useSelectedCustomer();
	const api = useService(APIService.serviceKey);
	const key = [`invoices`, customer?.id];
	return useSWR(key, () =>
		customer?.id ? api.invoices.getInvoices({ customerId: customer?.id }) : []
	);
}

export function useInvoiceFile(
	customerId: string | null | undefined,
	invoiceId: string | null | undefined,
	disabled?: boolean
) {
	const api = useService(APIService.serviceKey);
	const key = [`invoiceFile`, customerId, invoiceId, disabled];
	return useSWRImmutable(key, async () => {
		try {
			const file =
				customerId && invoiceId && !disabled
					? await api.invoices.getInvoiceFile({ customerId, invoiceId, download: true })
					: null;
			return file;
		} catch (e) {
			const err = e as ResponseError;
			const errorText = await err.response.text();
			throw new Error(errorText);
		}
	});
}
